<script context="module">
  import { writable, get } from "svelte/store";
  export const currentVideo = writable(null);
  let _curVideo;
  currentVideo.subscribe((v) => {
    _curVideo = v;
  });
</script>

<script>
  import { onMount } from "svelte";
  import playerjs from "player.js";
  import { withIntersection } from "../util/with-intersection";

  export let aspectRatio = "16 / 9";
  export let namespace = "337192";
  export let id = "908dcaa9-6343-49cb-b243-2dd423feaa48";
  export let muted = false;
  export let autoplay = false;
  export let loop = false;
  export let responsive = true;
  export let preload = true;
  export let lazy = true;

  let visible = lazy ? false : true;

  let iframe;
  onMount(() => {
    // init();
    return () => {
      // if (
      //   _curVideo &&
      //   _curVideo.id === id &&
      //   _curVideo.namespace === namespace
      // ) {
      //   currentVideo.update(() => null);
      // }
    };
  });

  // async function init() {
  //   const player = new playerjs.Player(iframe);
  //   player.on("play", () => {
  //     const cur = _curVideo;
  //     const isSame = cur && cur.id === id && cur.namespace === namespace;
  //     if (cur && !isSame) {
  //       // stop old video
  //       cur.player.pause();
  //     }

  //     if (!isSame) {
  //       currentVideo.update(() => {
  //         return {
  //           player,
  //           id,
  //           namespace,
  //         };
  //       });
  //     }
  //   });
  // }

  function withVideoPlayer(iframe, opts = {}) {
    const player = new playerjs.Player(iframe);
    player.on("play", () => {
      const cur = _curVideo;
      const isSame = cur && cur.id === id && cur.namespace === namespace;
      if (cur && !isSame) {
        // stop old video
        cur.player.pause();
      }

      if (!isSame) {
        currentVideo.update(() => {
          return {
            player,
            id,
            namespace,
          };
        });
      }
    });
    return {
      destroy() {
        if (
          _curVideo &&
          _curVideo.id === id &&
          _curVideo.namespace === namespace
        ) {
          currentVideo.update(() => null);
        }
      },
    };
  }

  function getURL(opts = {}) {
    const {
      namespace,
      id,
      muted = false,
      autoplay = false,
      loop = false,
      responsive = true,
      preload = true,
    } = opts;
    const url = new URL(
      `https://iframe.mediadelivery.net/embed/${namespace}/${id}`
    );
    const params = new URLSearchParams();
    params.append("loop", loop);
    params.append("autoplay", autoplay);
    params.append("muted", muted);
    params.append("preload", preload);
    params.append("responsive", responsive);
    url.search = params;
    return url.href;
  }
</script>

<div
  class="container noselect"
  style="aspect-ratio: {aspectRatio};"
  use:withIntersection={{
    onChange: (vis) => {
      if (!visible && vis) visible = true;
    },
  }}
>
  {#if visible}
    <iframe
      bind:this={iframe}
      title="Video"
      src={getURL({
        namespace,
        id,
        muted,
        autoplay,
        loop,
        responsive,
        preload,
      })}
      loading="lazy"
      style="border:0;position:absolute;top:0;height:100%;width:100%;"
      allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
      allowfullscreen="true"
    ></iframe>
  {/if}
</div>

<style>
  .container {
    overflow: hidden;
    background: black;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  iframe {
    position: absolute;
    /* display: none; */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
